import { Dispatch, SetStateAction } from "react";

import { Button, ColumnModal } from "@/components";
import { useAppProperties } from "@/hooks";
import { useTranslate } from "@/providers/context";

import { JoinLeaveButton } from "./JoinLeaveButton";

export const BlockInteractionModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { translate } = useTranslate();
  const { data: properties } = useAppProperties();

  const groupLabel = properties?.CommunityGroupLabelSingular ?? "group";
  const groupLabelPlural = properties?.CommunityGroupLabelPlural ?? "groups";

  return (
    <ColumnModal
      open={open}
      onOpenChange={setOpen}
      hideTrigger
      hideFooter
      cols={3}
      title={`${translate("Join")} ${groupLabel}`}
      titleClassName="capitalize"
    >
      <p className="p1-regular px-6">
        {`${translate("You need to join this")} ${groupLabel} ${translate("first to interact")}. ${translate("Joining this")} ${groupLabel} ${translate("will add it to Your")}`}
        <span className="capitalize">{` ${groupLabelPlural}.`}</span>
      </p>
      <div className="flex justify-end gap-3 p-6">
        <Button variant="secondary" onClick={() => setOpen(false)}>
          {translate("Cancel")}
        </Button>
        <JoinLeaveButton />
      </div>
    </ColumnModal>
  );
};
